// Event types that block an instructor's calendar: a holiday and any other
// reservation. They render as a backdrop, cannot be dragged, hide the free slots
// and never open the lesson modal. Mirrors config('events.blocking-types').
export const VACATION = 'vacation';
export const RESERVATION = 'reservation';
export const BLOCKING_TYPES = [VACATION, RESERVATION];

export function isBlockingEvent(event) {
    return !!event && BLOCKING_TYPES.indexOf(event.type) >= 0;
}

export function isReservationEvent(event) {
    return !!event && event.type === RESERVATION;
}
